import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Reveal from "./Reveal";
import { RECEIPTS } from "../data/content";
import { X, ZoomIn } from "lucide-react";

export default function Receipts() {
  const [active, setActive] = useState(null);
  return (
    <section id="receipts" data-testid="receipts-section" className="relative py-12 lg:py-16">
      <div className="max-w-6xl mx-auto px-5">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-400">Join The Team</p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            Men Lie. Women Lie.<br />
            <span className="hero-title-gradient">Deposits Don’t.</span>
          </h2>
          <p className="mt-5 text-[11px] sm:text-xs leading-relaxed text-slate-500 max-w-2xl mx-auto">
            (Results vary. All income shown is real and earned by licensed Breeze Wealth agents. Commissions depend on
            individual performance, comp level, carrier, product, and case size. Breeze Wealth Management makes no income
            guarantees or promises)
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {RECEIPTS.map((r, i) => (
            <Reveal key={r.carrier + i} delay={(i % 4) * 0.06}>
              <button
                data-testid={`receipt-card-${i}`}
                onClick={() => setActive(r)}
                className="receipt-card group relative w-full text-left glass-card rounded-xl overflow-hidden hover:border-sky-400/45 transition-colors duration-300"
              >
                <div className="relative overflow-hidden aspect-[3/4]">
                  <img src={r.url} alt={`${r.carrier} commission proof`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#030712]/90 via-[#030712]/20 to-transparent" />
                  <div className="absolute top-2.5 right-2.5 rounded-full bg-black/50 border border-white/15 p-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ZoomIn className="h-3.5 w-3.5 text-sky-300" />
                  </div>
                  <div className="absolute bottom-0 inset-x-0 p-3 sm:p-3.5">
                    <div className="rounded-xl bg-[#030712]/70 backdrop-blur-md border border-emerald-400/25 px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.45)]">
                      <div className="font-mono-num text-base sm:text-lg font-bold text-emerald-300 leading-none drop-shadow-[0_0_10px_rgba(52,211,153,0.4)]">{r.amount}</div>
                      <div className="mt-1.5 text-[9px] sm:text-[10px] font-bold tracking-[0.14em] text-sky-200/95 uppercase truncate">{r.carrier}</div>
                      <div className="mt-0.5 text-[8px] sm:text-[9px] font-medium tracking-[0.1em] text-slate-400 uppercase truncate">{r.date}</div>
                    </div>
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="receipt-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[90] flex items-center justify-center bg-black/85 backdrop-blur-sm p-5"
            onClick={() => setActive(null)}
          >
            <motion.div
              initial={{ scale: 0.92, y: 24 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.94, y: 16 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="relative max-w-3xl w-full glass-card rounded-3xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                data-testid="receipt-lightbox-close"
                onClick={() => setActive(null)}
                className="absolute top-4 right-4 z-10 rounded-full bg-black/60 border border-white/15 p-2 text-white hover:bg-black/80 transition-colors"
              >
                <X className="h-4 w-4" />
              </button>
              <img src={active.url} alt={active.carrier} className="w-full object-contain max-h-[70vh]" />
              <div className="p-5 flex items-center justify-between">
                <div>
                  <div className="font-mono-num text-xl font-semibold text-emerald-400">{active.amount}</div>
                  <div className="text-xs tracking-[0.14em] text-slate-400 uppercase mt-1">{active.carrier}</div>
                </div>
                <div className="font-mono-num text-sm text-slate-500">{active.date}</div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
